

import { Box, SxProps, Theme } from '@mui/material';
import { FC, MouseEventHandler, useMemo } from 'react';
import { IHasChildren } from './types/IHasChildren';

interface IDropdownProps extends IHasChildren {
    anchor: HTMLElement | null;
    open: boolean;
    position?: 'bottom' | 'left' | 'right',
    sx?: SxProps<Theme>;
    onClick?: MouseEventHandler | undefined;
}

const Dropdown: FC<IDropdownProps> = ({
    anchor,
    open,
    position,
    sx,
    onClick,
    children
}) => {

    const bounds = anchor?.getBoundingClientRect();

    const pos = useMemo(() => {
        switch (position) {
            case 'bottom':
            case undefined:
                return {
                    top: bounds?.height ?? '0px',
                    right: undefined,
                    left: '0px',
                    bottom: undefined
                }
                
            case 'left':
                return {
                    top: '0px',
                    right: bounds?.width ?? '100%',
                    left: undefined,
                    bottom: undefined
                }
            default: 
                return {
                    top: bounds?.height ?? '0px',
                    right: undefined,
                    left: '0px',
                    bottom: undefined
                }
                
        }
    }, [position, bounds]);

    return (
        <Box
            sx={{
                ...sx,
                backgroundColor: 'white',
                position: 'absolute',
                top: pos.top,
                left: pos.left,
                right: pos.right,
                bottom: pos.bottom,
                display: open ? 'block' : 'none',
                boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
            }}
            onClick={onClick}
        >
            {children}
        </Box>
    )
}

export default Dropdown